import React from "react";
import TitleListItem from "../TitleListItem/TitleListItem";
import ListGroup from "react-bootstrap/ListGroup";
import memoizeOne from "memoize-one";

class TitleList extends React.Component {
  constructor(props) {
    super(props);
    this.state = { currentListCount: 0, renderingID: 0 };

    this.filter = memoizeOne((titles, keyword) =>
      titles.filter(aTitle => {
        const idContained =
          aTitle.production_title != null &&
          aTitle.production_title.toLowerCase().includes(keyword.toLowerCase());
        const nameContained = aTitle.name
          .toLowerCase()
          .includes(keyword.toLowerCase());

        return idContained || nameContained;
      })
    );
  }

  componentDidMount() {
    this.recursive(this.state.renderingID);
  }

  recursive(renderingID) {
    setTimeout(() => {
      if (this.state.renderingID !== renderingID) {
        return;
      }

      this.setState({
        currentListCount: this.state.currentListCount + 10
      });

      const filteredList = this.filter(this.props.titles, this.props.keyword);

      if (this.state.currentListCount < filteredList.length) {
        this.recursive(renderingID);
      }
    }, 0);
  }

  static getDerivedStateFromProps(props, state) {
    if (
      props.titles !== state.prevTitles ||
      props.keyword !== state.prevKeyword
    ) {
      return {
        currentListCount: 0,
        renderingID: state.renderingID + 1,
        prevTitles: props.titles,
        prevKeyword: props.keyword
      };
    }

    return null;
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.titles !== prevProps.titles ||
      this.props.keyword !== prevProps.keyword
    ) {
      this.recursive(this.state.renderingID);
    }
  }

  render() {
    const filteredList = this.filter(this.props.titles, this.props.keyword);

    const { cookies } = this.props;
    const isAdmin = cookies.get("role") === "admin";

    const renderingFilteredList = filteredList.slice(
      0,
      this.state.currentListCount + 1
    );

    return (
      <ListGroup variant="flush">
        {renderingFilteredList.map(aTitle => (
          <TitleListItem
            key={aTitle.id}
            isAdmin={isAdmin}
            title={aTitle}
            editLoading={this.props.editLoading}
            edittingTitleID={this.props.edittingTitleID}
            handleEdit={this.props.handleEdit}
            handleEditFire={this.props.handleEditFire}
            handleDelete={this.props.handleDelete}
          />
        ))}
      </ListGroup>
    );
  }
}

export default TitleList;
